<div class="modal-content">
  <div class="modal-header">
    <h6 class="modal-title" id="vcenter">{{ 'common.modal_historic.header' | translate }}</h6>
    <a (click)="modal.close('')" type="button" class="close">×</a>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <p-table [value]="data"
                 [paginator]="true"
                 [rows]="10"
                 [totalRecords]="data.length">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th
                class="text-center">{{ 'dataform.implementation.tabs.detail_information.table.uploaded_on' | translate }}
              </th>
              <th
                class="text-center">{{ 'dataform.implementation.tabs.detail_information.table.uploaded_by' | translate }}
              </th>
              <th
                class="text-center">{{ 'dataform.implementation.tabs.detail_information.table.file_name' | translate }}
              </th>
              <th class="text-center">{{ 'dataform.implementation.tabs.detail_information.table.status' | translate }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr>
              <td class="text-center">{{ rowData.createDate }}</td>
              <td class="text-center">{{ rowData.createUser }}</td>
              <td class="text-center">{{ rowData.fileName }}</td>
              <td class="text-center">
                <p-tag
                  [severity]="rowData.status==1 ? 'success' : 'danger'"
                  [value]="rowData.status==1? ('common.tags.current' | translate) : ('common.tags.old' | translate)">
                </p-tag>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
